function refreshCartCount() {
  fetch('/cart.js').then(r=>r.json()).then(cart=>{
    const el = document.getElementById('CartCount');
    if (el) {
      el.textContent = cart.item_count;
      el.parentElement.style.display = cart.item_count > 0 ? 'flex' : 'none';
    }
  });
}
document.addEventListener('cart:updated', refreshCartCount);

